/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DataTableViewType {
    Table = 1,
    Gantt = 2,
    Map = 3,
}
